import Cookies from "js-cookie";

export const handleUnauthorized = () => {
  window.location.href = "/authentication/sign-in";
};

const postFetch = async (url, form, headers) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
    cache: "no-store",
    method: "POST",
    headers,
    body: form,
  });

  if (res.ok) {
    const data = await res.json();
    return data;
  } else {
    // if (res.status === 401) {
    //     handleUnauthorized();
    // }
    return {
      status: "خطا در اتصال به سرور!",
      message: res.status,
    };
  }
};

const postFetchWithBody = async (url, data, headers) => {
  const token = Cookies.get("login_token");
  if (!token) {
    return {
      status: "error",
      message: "توکنی یافت نشد!",
    };
  }
  const res = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
    cache: "no-store",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...headers,
    },
    body: JSON.stringify(data),
  });

  if (res.status === 401) {
    handleUnauthorized();
  }
  return res.json();
};

const postFetchWithBodyHandler = async (url, data, headers) => {
  const token = Cookies.get("login_token");
  if (!token) {
    return {
      status: "error",
      message: "توکنی یافت نشد!",
    };
  }
  const res = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
    cache: "no-store",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...headers,
    },
    body: JSON.stringify(data),
  });

  if (res.status === 401) {
    handleUnauthorized();
  }
  return {
    data:res.json(),
    status: res.status,
  };
};

const postFetchWithOutForm = async (url, headers) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
    cache: "no-store",
    method: "POST",
    headers,
  });

  if (res.ok) {
    const data = await res.json();
    return data;
  } else {
    if (res.status === 401) {
      handleUnauthorized();
    }
    return {
      status: "خطا در اتصال به سرور!",
      message: res.status,
    };
  }
};

const postFetchWithToken = async (url, form) => {
  const token = Cookies.get("login_token");
  if (!token) {
    return {
      status: "error",
      message: "توکنی یافت نشد!",
    };
  }
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
      cache: "no-store",
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form,
    });

    if (res.ok) {
      const data = await res.json();
      return data;
    } else {
      if (res.status === 401) {
        handleUnauthorized();
      }
      return {
        status: "error",
        message: res.status,
      };
    }
  } catch (ex) {
    return {
      status: "error",
      message: "خطا در اتصال به سرور",
    };
  }
};

const getFetch = async (url) => {
  const token = Cookies.get("login_token");

  if (!token) {
    return {
      status: "error",
      message: "توکنی یافت نشد!",
    };
  }

  const res = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
    cache: "no-store",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.ok) {
    const data = await res.json();
    return data;
  } else {
    if (res.status === 401) {
      handleUnauthorized();
    }
    return {
      status: "error",
      message: "خطا در اتصال به سرور!",
    };
  }
};

export { postFetch, getFetch,postFetchWithBodyHandler, postFetchWithToken, postFetchWithOutForm, postFetchWithBody };
